import {
  getAdapter,
  setNetworkAdapter,
  fetchAdapter,
  type FetchCredentials,
  type NetworkAdapter,
  type Req,
} from './adapter';
import { getApiOrigin } from './api-origin';

export { getApiOrigin, setNetworkAdapter, type NetworkAdapter, fetchAdapter };

type options = {
  credentials: FetchCredentials;
};

export async function send<T>(
  req: Req,
  options?: options
): Promise<{ status: number; data: T }> {
  const origin = getApiOrigin();
  return await getAdapter()(req, { ...options, origin });
}
